<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <div v-if="Array.isArray(value)">
      <div class="displayed-list">{{ $t(label) }}</div>
      <ul class="inner-list">
        <EcsBusinessProcessElement
          v-for="(item, index) in value"
          :key="`${item.label}-${index}`"
          :label="item.label"
          :value="item.value"
        />
      </ul>
    </div>
    <ul v-else-if="value !== null" class="inner-list">
      <li class="displayed-item">{{ $t(label, [value]) }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EcsBusinessProcessElement',
  props: {
    value: {
      type: [Array, String, Number],
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
ul {
  list-style: none;
}
.inner-list li {
  list-style: disc;
}
.displayed-list,
.displayed-item {
  font-size: 12px;
}
.displayed-item::marker {
  display: none;
}
</style>
